<template>
  <div class="general-info thank-you-block">
    <div class="general-info__container">
      <div class="general-info-department">
        <div class="general-info-department__thank">
          <BlockThankYou />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockThankYou from '@/components/BlockThankYou.vue'

export default {
  name: 'AppThankYouBlock',
  components: { BlockThankYou },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
</style>
